/**
 * Memory API Service
 * Centralized logic for communication with memory API
 */

class MemoryApiService {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }

    /**
     * Fetches memory information for given account and server
     * @param {string} accountName - Account name
     * @param {string} serverUrl - Server URL
     * @returns {Promise<Object>} Memory info response
     */
    async getMemoryInfo(accountName, serverUrl) {
        try {
            const response = await fetch(`${this.baseUrl}/api/memory/info`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    account_name: accountName || "",
                    server_url: serverUrl || "",
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            return { success: true, data };
        } catch (error) {
            console.error('Memory API Error:', error);
            return { 
                success: false, 
                error: error.message || 'Failed to fetch memory info' 
            };
        }
    }

    /**
     * Buys memory (if needed in the future)
     * @param {Object} params - Parameters for memory purchase
     * @returns {Promise<Object>} Buy memory response
     */
    async buyMemory(params) {
        try {
            const response = await fetch(`${this.baseUrl}/api/memory/buy`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(params),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            return { success: true, data };
        } catch (error) {
            console.error('Buy Memory API Error:', error);
            return { 
                success: false, 
                error: error.message || 'Failed to buy memory' 
            };
        }
    }
}

export default MemoryApiService; 